import useSuggestedViewFields from '@API/project/useSuggestedViewFields';
import { DashboardView } from '@experiment-management-shared/types';
import { getSuggestedView } from '@experiment-management-shared/utils/EMView';
import useDeepMemo from '@shared/hooks/useDeepMemo';
import { useApplyAutoGeneratedSections } from './useApplyAutoGeneratedSections';

export const useAutoGeneratedView = ({
  enabled = true,
  experimentKeys = null
}: { enabled?: boolean; experimentKeys?: string[] | null } = {}) => {
  const {
    data: suggestedViewFields,
    isSuccess: areSuggestedViewFieldsLoaded
  } = useSuggestedViewFields();

  const viewWithoutSections = useDeepMemo(() => {
    if (!areSuggestedViewFieldsLoaded || !suggestedViewFields) {
      return null;
    }

    return getSuggestedView(suggestedViewFields) as DashboardView;
  }, [areSuggestedViewFieldsLoaded, suggestedViewFields]);

  const {
    sections: sectionsWithAutogeneratedPanels
  } = useApplyAutoGeneratedSections({
    config: {
      cacheTime: 0,
      enabled,
      // change refetchinterval logic
      refetchInterval: false,
      refetchOnMount: true
    },
    enabled,
    sections: viewWithoutSections?.panels.sections,
    viewExperimentKeys: experimentKeys
  });

  return useDeepMemo(() => {
    if (!viewWithoutSections || !sectionsWithAutogeneratedPanels) return null;

    return {
      ...viewWithoutSections,
      panels: {
        ...viewWithoutSections.panels,
        sections: sectionsWithAutogeneratedPanels
      }
    } as DashboardView;
  }, [sectionsWithAutogeneratedPanels, viewWithoutSections]);
};
